<script setup>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);

const ProjectVideoDashboard = defineAsyncComponent(() =>
    import(
        "../../components/Logistics/ProjectVideoDashboard/Dashboard.vue"
    )
);

const props = defineProps({
    project_id: {
        type: String,
        required: false,
    },
});
</script>

<template>
    <ProjectVideoDashboard :project_id="props.project_id" />
</template>
